"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Colors = require("../00_environment/Colors");

var _Fonts = require("../00_environment/Fonts");

var _Button = _interopRequireDefault(require("../01_atoms/Button"));

var _RightPaneWidgetFrame = _interopRequireDefault(require("../01_atoms/RightPaneWidgetFrame"));

var _TicketDetails = _interopRequireDefault(require("./TicketDetails"));

var _TripPriceDetails = _interopRequireDefault(require("./TripPriceDetails"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TicketDetailsCardWidget = function TicketDetailsCardWidget(_ref) {
  var sdk = _ref.sdk,
      trip = _ref.trip,
      _ref$focusedLeftItemI = _ref.focusedLeftItemId,
      focusedLeftItemId = _ref$focusedLeftItemI === void 0 ? null : _ref$focusedLeftItemI,
      _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? function () {} : _ref$onConfirm,
      nPassengers = _ref.nPassengers,
      locale = _ref.locale,
      _ref$translator = _ref.translator,
      t = _ref$translator === void 0 ? function (txt) {
    return txt;
  } : _ref$translator,
      isReturn = _ref.isReturn,
      isOneWayTrip = _ref.isOneWayTrip,
      _ref$scrollTop = _ref.scrollTop,
      scrollTop = _ref$scrollTop === void 0 ? 0 : _ref$scrollTop;
  return /*#__PURE__*/_react["default"].createElement(_RightPaneWidgetFrame["default"], {
    style: {
      marginTop: 30
    },
    headerComponent: function headerComponent() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: (0, _Fonts.withTopBarFont)({
          padding: '24px 40px',
          backgroundColor: _Colors.topBarBgColor,
          color: 'white',
          width: '100%',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center'
        })
      }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontWeight: 'normal'
        }
      }, isReturn ? 'Return trip' : 'Outbound trip'), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontSize: '1.8rem',
          fontWeight: 'normal',
          marginTop: 5,
          marginBottom: 2
        }
      }, sdk.routes.humanPricingForRoute(trip, nPassengers, false)), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontSize: '1rem',
          fontWeight: 'normal'
        }
      }, "".concat(nPassengers, " ").concat(t('passenger')).concat(nPassengers > 1 ? 's' : ''))), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        style: (0, _Fonts.withTopBarFont)({
          color: 'white',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
          alignItems: 'flex-start',
          textAlign: 'left'
        }),
        primary: true,
        onClick: onConfirm
      }, /*#__PURE__*/_react["default"].createElement("div", null, "".concat(t('Continue'))), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          fontSize: '0.9rem',
          fontWeight: 'normal'
        }
      }, t('to fill out trip details'))));
    },
    focusedLeftItemId: focusedLeftItemId,
    scrollTop: scrollTop
  }, /*#__PURE__*/_react["default"].createElement(_TicketDetails["default"], {
    title: t('Details'),
    topRightLabel: null,
    ticketDetails: trip,
    nPassengers: nPassengers,
    locale: locale
  }), /*#__PURE__*/_react["default"].createElement(_TripPriceDetails["default"], {
    style: {
      marginTop: 30
    },
    trip: trip,
    numberOfPassengers: nPassengers,
    isOneWayTrip: isOneWayTrip,
    translatorForNamespace: sdk.i18n.translatorForNamespace
  }));
};

var _default = TicketDetailsCardWidget;
exports["default"] = _default;